import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  productDetailsReducer,
  productListReducer,
  productFeaturedListReducer,
} from "./Reducers/ProductReducers";
import { cartReducer } from "./Reducers/CartReducers";
import { categoryStoreListReducer } from "./Reducers/CategoryReducers";
import { bannerStoreListReducer } from "./Reducers/BannerReducers";
import { publicStoreSettingsReducer } from "./Reducers/StoreSettingReducers";
import {
  instagramVideoStoreListReducer,
} from "./Reducers/InstagramVideoReducers";
import { instagramPhotoStoreListReducer } from "./Reducers/InstagramPhotoReducers";

const reducer = combineReducers({
  productList: productListReducer,
  productFeaturedList: productFeaturedListReducer,
  productDetails: productDetailsReducer,
  cart: cartReducer,
  categoryStoreList: categoryStoreListReducer,
  bannerStoreList: bannerStoreListReducer,
  publicStoreSettings: publicStoreSettingsReducer,
  instagramVideoStoreList: instagramVideoStoreListReducer,
  instagramPhotoStoreList: instagramPhotoStoreListReducer,
});

const safeParse = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || raw === "undefined" || raw === "null") return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const cartItemsFromLocalStorage = safeParse("cartItems", []);

const initialState = {
  cart: {
    cartItems: cartItemsFromLocalStorage,
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;